<template>
    <div>
        <Form :model="searchItem" :label-width="85" label-position="left" :disabled="loading" ref="formValidate"  :show-message="false" style="margin-top:20px">
            <div class="searchRow">
                <div style="display:flex">
                    <FormItem label="角色名">
                        <Input v-model="searchItem.roleName" clearable/>
                    </FormItem>
                    <Button type="primary" style="margin-left:20px" @click="getData()">查询</Button>
                </div>
                <div class="btnGroup">
                </div>
            </div>
        </Form>
        <Table stripe border :columns="columns" :loading="loading" :data="dataTable">
            <!-- <template slot="slot1" slot-scope="{ row }">
                <Button size="small" type="primary" @click="openPop(1,row)">分配</Button>
            </template>
            <template slot="slot2" slot-scope="{ row }">
                <Button size="small" type="primary" @click="openPop(2,row)">分配</Button>
            </template> -->
            <template slot="slot3" slot-scope="{ row }">
                <Button size="small" type="primary" @click="openPop(3,row)">分配</Button>
            </template>
            <template slot="slot4" slot-scope="{ row }">
                <Button size="small" type="primary" @click="openPop(4,row)">分配</Button>
            </template>
            <template slot="slot5" slot-scope="{ row }">
                <Button size="small" type="primary" @click="openPop(5,row)">分配</Button>
            </template>
            <template slot="slot7" slot-scope="{ row }">
              <Button size="small" type="primary" @click="openPop(7,row)">分配</Button>
          </template>
            <template slot="delete" slot-scope="{ row }">
                <Button icon="md-create"   type="warning" size="small"  @click="openPop(6,row)">编辑</Button>
                <Button icon="md-trash" type="error" size="small" :disabled="row.beDeleteFlag == '1' " @click="opendelete(row)" style="margin-left:15px">删除</Button>
            </template>
        </Table>
        <div style="margin: 15px 0">
          <Page :total="this.totalNum" style="float:left" @on-change="pageChange" />
          <Button type="primary" icon="md-add" style="float:right" @click="addData(9)">新增</Button>
        </div>

        <Modal v-model="addPop" :title="transferType==6?'编辑角色权限':'新增角色权限'" :mask-closable="false">
            <Form :model="addItem" :label-width="110" label-position="left" ref="addFormValidate" :rules="ruleValidate">
                <FormItem label="角色名" prop="roleName">
                    <Input v-model="addItem.roleName" />
                </FormItem>
                <FormItem label="角色描述" prop="roleDescribe">
                    <Input v-model="addItem.roleDescribe" />
                </FormItem>
            </Form>
            <Spin size="large" fix v-if="spinShow"></Spin>
            <div class="bottomBtn" slot="footer">
                <Button type="primary" @click="addCancel()">取消</Button>
                <Button  type="primary" @click="addSaveData()" style="margin-left:15px">保存</Button>
            </div>
        </Modal>

        <Modal v-model="visualPop" :title="titleName" :mask-closable="false">
            <TreeComponent :treeData="treeData"  ref="treeDataDom" @getTreeChecked="getTreeChecked"></TreeComponent>
            <Spin size="large" fix v-if="spinShow"></Spin>
            <div class="bottomBtn" slot="footer">
                <Button @click="cancel()">取消</Button>
                <Button type="primary" @click="saveData()" style="margin-left:15px">保存</Button>
            </div>
        </Modal>
        <Modal v-model="visualPop2" :title="titleName" :mask-closable="false">
            <TreeComponent :treeData="treeData2" ref="treeDataDom2" @getTreeChecked="getTreeChecked"></TreeComponent>
            <Spin size="large" fix v-if="spinShow"></Spin>
            <div class="bottomBtn" slot="footer">
                <Button @click="cancel()">取消</Button>
                <Button type="primary" @click="saveData()" style="margin-left:15px">保存</Button>
            </div>
        </Modal>
        <Modal v-model="visualPop1" :title="titleName" :mask-closable="false">
            <TabsTransferComponent :transferData="transferData" :transferTitle="transferTitle" @transferChange="transferChange">
            </TabsTransferComponent>
            <Spin size="large" fix v-if="spinShow"></Spin>
            <div class="bottomBtn" slot="footer">
                <Button @click="cancel()">取消</Button>
                <Button type="primary"  @click="saveData()" style="margin-left:15px">保存</Button>
            </div>
        </Modal>
        <Modal v-model="showRolePosition" title="角色职位" width="880px" footer-hide>
          <Form :label-width="95" label-position="left">
            <Row>
              <Col span="10">
                <FormItem label="组织:">
                  <Input v-model="orgName"></Input>
                </FormItem>
              </Col>
              <Col span="10" offset="1">
                <FormItem label="中文职位:">
                  <Input v-model="c_name"></Input>
                </FormItem>
              </Col>
              <Col span="1" offset="1">
                <Button type="primary" @click="total1 = 0,pageInfo1.pageNo = 1,selectRole()">查询</Button>
              </Col>
            </Row>
          </Form>
          <Table border stripe :columns="rolesColumns" :data="rolesData" :loading="loading2" @on-select-cancel="handleCancel1"  @on-select="handleSelect1" @on-select-all="handleSelectAll1" @on-select-all-cancel="handleCancelSelectAll1">
          </Table>
          <Page style="margin-top: 20px; text-align: right" :total="total1" @on-change="pageChange1"/>
          <Row style="margin-top:15px">
            <Col span="24" style="text-align: center">
              <Button :disabled="disabled"  @click="saveData()">保存</Button>
            </Col>
          </Row>
        </Modal>
        <Modal v-model="empoloyee" title="其他权限分配" width="880px" footer-hide>
          <Form :label-width="110" label-position="left">
            <Row>
              <Col span="10">
                <FormItem label="权限类型：">
                  <Select v-model="powerType" clearable placeholder="">
                    <Option v-for="(item, i) in TypeList" :key="i" :value="item.code" >{{ item.name1 }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="1" offset="1">
                <Button type="primary" @click="(total2 = 0), (pageInfo2.pageNo = 1), getp()">查询</Button>
              </Col>
            </Row>
          </Form>
          <Table border stripe ref="table2" :columns="otherRolesColumns" :data="otherRolesData" :loading="loading2" 
          @on-select-cancel="handleCancel"  @on-select="handleSelect2" @on-select-all="handleSelectAll" @on-select-all-cancel="handleCancelSelectAll2">
          </Table>
          <Page style="margin-top: 20px; text-align: right" :total="total2" @on-change="pageChange2"/>
          <Row style="margin-top:15px">
            <Col span="24" style="text-align: center">
              <Button  :disabled="disabled"  @click="saveData()">保存</Button>
            </Col>
          </Row>
        </Modal>
        <Modal v-model="PersonnelScope" title="人员范围分配" width="880px" footer-hide>
          <PersonnelScope  ref="personnelScope" @closePersonnelScope="closePersonnelScope"></PersonnelScope>
          <Spin size="large" fix v-if="spinShow"></Spin>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
import TabsTransferComponent from './../components/TabsTransferComponent'
import TreeComponent from './../components/TreeComponent'
import PersonnelScope from './../components/PersonnelScope'
export default {
    components:{
        TabsTransferComponent,
        TreeComponent,
        PersonnelScope
    },
    data(){
        return{
            loading:false,
            spinShow:false,
            searchItem:{
                roleName:''
            },
            totalNum: 0, //table数据总条数
            pageInfo: {
                pageNo: 1, //页码
                pageSize: 10, //每页数据条数
            },
            columns:[
                {
                    title: '角色名',
                    key: 'roleName',
                    minWidth: 200,
                    align: "center"
                },
                {
                    title: '角色描述',
                    align: "center",
                    key: 'roleDescribe',
                    minWidth: 200,
                },
                // {
                //     title: '角色组织',
                //     align: "center",
                //     slot: "slot1",
                //     minWidth: 100,
                // },
                // {
                //     title: '角色职位',
                //     align: "center",
                //     slot: "slot2",
                //     minWidth: 100,
                // },
                {
                    title: '角色用户组',
                    align: "center",
                    slot: "slot3",
                    minWidth: 100,
                },
                {
                    title: '菜单权限分配',
                    align: "center",
                    slot: "slot4",
                    minWidth: 100,
                },
                // {
                //     title: '其他权限分配',
                //     align: "center",
                //     slot: "slot5",
                //     minWidth: 100,
                // },
                {
                    title: '人员范围分配',
                    align: "center",
                    slot: "slot7",
                    minWidth: 100,
                },
                {
                    title: '操作',
                    align: "center",
                    slot: "delete",
                    minWidth: 200,
                }
            ],
            dataTable:[],
            addPop:false,
            addItem:{
                roleName:'',
                roleDescribe:'',
            },
            visualPop:false,
            visualPop1:false,
            transferType:6,
            transferData:[],
            whereItem:{
                whereValue:''
            },
            userId:'',
            transferTitle:'',
            ruleValidate: {
                roleName: [
                    { required: true, message: '角色名不能为空', trigger: 'blur' }
                ],
                roleDescribe: [
                    { required: true, message: '角色描述不能为空', trigger: 'blur' }
                ],
            },
            updataItem:{},
            updatedData:[],
            roleId:'',
            roleList:[],
            treeData:[],
            treeData2:[],
            selectVal:null,
            empoloyee:false,
            titleName:'',
            otherRolesColumns:[
              {
                type: 'selection',
                width: 60,
                align: 'center'
              },
              {
                title: "权限类型",
                key: "powerType",
                align: "center",
                render: (h,params)=>{
                  var powerType1 = ''
                  this.TypeList ? this.TypeList.forEach((item,index)=>{
                    if(item.code == params.row.powerType){
                      powerType1 = item.name1
                    }
                  }):''
                  return h("span", powerType1);
                },
              },
              {
                title: "权限值",
                key: "powerKey",
                align: "center",
              },
              {
                title: "权限描述",
                key: "powerDescribe",
                align: "center",
              },
            ],
            otherRolesData:[],
            TypeList:[],
            powerType:null,
            pageInfo2: {
              itemCount: 0,
              pageNo: 1,
              pageSize: 10,
            },
            total2: 0,
            roleIdVal:null,
            selectList:[],
            loading2:false,
            visualPop2:false,
            showRolePosition:false,
            rolesColumns:[
              {
                type: 'selection',
                width: 60,
                align: 'center'
              },
              {
                title: "组织",
                key: "orgName",
                width:'320',
                align: "center",
              },
              {
                title: "职位中文名称",
                key: "c_name",
                align: "center",
              },
              {
                title: "职位英文名称",
                key: "e_name",
                align: "center",
              },
            ],
            PersonnelScope:false,
            rolesData:[],
            pageInfo1: {
              itemCount: 0,
              pageNo: 1,
              pageSize: 10,
            },
            disabled:false,
            total1: 0,
            c_name:null,
            orgName:null,
        }
    },
    created(){
        let userInfo=JSON.parse(sessionStorage.getItem('userInfo'))
        this.userId = userInfo.userId
        this.getData()
    },
    methods:{
        getData(){
            let json={
                roleId:'',
                ...this.searchItem,
                ...this.pageInfo
            }
            this.loading=true
            axios.post('/roleMaster/selectAllRoleMasterInfo',json).then(res => {
                this.loading=false
                if(res) {
                    this.dataTable=res.data
                    this.totalNum=Number(res.pageInfo.total)
                }
            })
        },
        //打开列表弹窗
        openPop(index,row){
            this.transferType=index
            this.roleId=row.roleId
            this.transferData=[]
            this.updatedData=[]
            this.treeData=[]
            if(index==1){
                this.visualPop=true
                this.spinShow=true
                let obj={
                    roleId:row.roleId,
                }
                axios.post('/roleMaster/selectOrgAllList',obj).then(res => {
                  if(res) {
                    this.treeData=res.organizationStructureList
                      // this.treeData =row.organizationStructureList
                    this.$refs.treeDataDom.treeDataList=this.treeData
                    this.$refs.treeDataDom.toggleExpand(this.treeData,true)
                    this.getUpdatedData(res.organizationStructureList)
                  }
                  this.spinShow=false
                })
            }else if(index==2){
                this.showRolePosition=true
                this.loading2 = true
                this.roleIdVal = row.roleId
                this.selectList = []
                this.pageInfo1.pageNo = 1
                this.total1 = 0
                let obj={
                  roleId: this.roleId,
                }
                axios.post("/roleMaster/selectPosPowerList", obj).then((res1) => {
                  if(res1 && res1.length!=0){
                    this.selectList = res1.filter(item=>{
                      return item.beUsed == "1"
                    })
                    const newMap = new Map();
                    this.selectList = this.selectList.filter(item => !newMap.has(item.structurecode) && newMap.set(item.structurecode, 1));
                    this.selectRole()
                    console.log(this.selectList)
                  }
                });
            }else if(index==3){
              this.titleName="角色用户组"
                this.visualPop1=true
                let obj={
                    roleId:row.roleId,
                }
                this.spinShow=true
                axios.post('/roleMaster/selectUserGroupList ',obj).then(res => {
                  if(res) {
                    this.transferData = res.userGroupMasterList.map((el) => {
                        return{
                            ...el,
                            key:el.groupId,
                            label:el.groupName,
                            type:el.beUsed
                        }
                    })
                    this.updatedData=res.userGroupMasterList.filter(item => item.beUsed=='1').map(el => {
                        return el
                    })
                  }
                  this.spinShow=false
                })
            }else if(index==4) {
              this.titleName="菜单权限分配"
              this.visualPop2=true
              this.spinShow=true
              let obj={
                  roleId:row.roleId,
              }
              axios.post('/roleMaster/selectMenuPowerList',obj).then(res => {
                if(res) {
                  this.treeData2 =res.menuMasterList
                  this.$refs.treeDataDom2.treeDataList=this.treeData2
                  this.$refs.treeDataDom2.toggleExpand(this.treeData2,true)
                  this.getUpdatedData(res.menuMasterList)
                }
                this.spinShow=false
              })
            }else if(index == 5){
              this.titleName="其他权限分配"
              this.loading2 = true
              this.empoloyee = true
              this.selectList = []
              this.roleIdVal = row.roleId
              this.pageInfo2.pageNo = 1
              this.total2 = 0
              axios.post('/roleMaster/selectOtherPowerLabel',{}).then(res => {
                if(res){
                  this.TypeList = res.powerType
                }
              })
              this.$set(this,'powerType',"AP01")
              let obj={
                roleId: this.roleId,
              }
              axios.post("/roleMaster/selectOtherPowerList", obj).then((res1) => {
                if(res1 && res1.length!=0){
                  this.selectList = res1.filter(item=>{
                    return item.beUsed == "1"
                  })
                  const newMap = new Map();
                  this.selectList = this.selectList.filter(item => !newMap.has(item.powerId) && newMap.set(item.powerId, 1));
                  this.getp()
                }
              });
            }else if(index == 7){
              this.titleName="人员范围分配"
              this.PersonnelScope=true
              this.spinShow=true
              this.$refs.personnelScope.selectPersonnelScope(row)
            }
            else if(index==6){
                this.addPop=true
                this.addItem=JSON.parse(JSON.stringify(row))
            }
            this.spinShow=false
        },
        selectRole(){
          this.loading2 = true
          let Obj = {
            roleId: this.roleIdVal,
            orgName: this.orgName,
            c_name: this.c_name,
            pageNo: this.pageInfo1.pageNo,
            pageSize: this.pageInfo1.pageSize,
          }
          axios.post("/roleMaster/selectPosPowerList", Obj).then((res) => {
            if(res){
              this.rolesData = res.data
              this.total1 = Number(res.pageInfo.total)
              this.rolesData.forEach(item=>{
                if(item.beUsed == "1"){
                  item._checked = true
                }
              })
              const res1 = new Map();
              this.selectList = this.selectList.filter(item => !res1.has(item.structurecode) && res1.set(item.structurecode, 1));
              this.updateChecked1()
              console.log(this.selectList,111)
            }
            this.loading2 = false
          });
        },
        pageChange1(val){
          this.pageInfo1.pageNo = val;
          this.selectRole()
        },
        handleSelect1(selection, row) {
          this.selectList.push(row);
          console.log(this.selectList,111)
        },
        handleCancel1(selection, row) {
          let newProductData = this.selectList.filter(item => {
            return item.structurecode !== row.structurecode
          })
          this.selectList = newProductData
          console.log(this.selectList,111)
        },
        handleSelectAll1(selection) {
          selection.forEach(item => {
            this.selectList.push(item)
          });
          // 去重
          const res = new Map();
          this.selectList = this.selectList.filter(item => !res.has(item.structurecode) && res.set(item.structurecode, 1));
          console.log(this.selectList,111)
        },
        closePersonnelScope(){
          this.PersonnelScope=false
        },
        handleCancelSelectAll1(selection) {
          var flag = true
          let arr = []
          for (var i = 0; i < this.selectList.length; i++) {
            flag = true
            for (var j = 0; j < this.rolesData.length ; j++) {
              if (this.selectList[i].structurecode == this.rolesData[j].structurecode) {
                flag = false
                break;
              }
            }
            if(flag){
              arr.push(this.selectList[i])
            }
          }
          this.selectList = arr
          console.log(this.selectList,111)
        },
        updateChecked1() {
          for (var i = 0; i < this.rolesData.length; i++) {
            this.rolesData[i]._checked = false;
            for (var j = 0; j < this.selectList.length; j++) {
              if (this.selectList[j].structurecode === this.rolesData[i].structurecode) {
                this.rolesData[i]._checked = true;
                this.selectList[j].beUsed = "1";
              }
            }
          }
        },



        getp(){
          this.loading2 = true
          let Obj = {
            roleId: this.roleIdVal,
            powerType: this.powerType,
            pageNo: this.pageInfo2.pageNo,
            pageSize: this.pageInfo2.pageSize,
          }
          axios.post("/roleMaster/selectOtherPowerList", Obj).then((res) => {
            if(res){
              this.otherRolesData = res.data
              this.total2 = Number(res.pageInfo.total)
              this.otherRolesData.forEach(item=>{
                if(item.beUsed == "1"){
                  item._checked = true
                }
              })
              const res1 = new Map();
              this.selectList = this.selectList.filter(item => !res1.has(item.powerId) && res1.set(item.powerId, 1));
              this.updateChecked()
            }
            this.loading2 = false
          });
        },
        pageChange2(val){
          this.pageInfo2.pageNo = val;
          this.getp()
        },
        handleSelect2(selection, row) {
          this.selectList.push(row);
        },
        handleCancel(selection, row) {
          let newProductData = this.selectList.filter(item => {
            return item.powerId !== row.powerId
          })
          this.selectList = newProductData
        },
        handleSelectAll(selection) {
          selection.forEach(item => {
            this.selectList.push(item)
          });
          // 去重
          const res = new Map();
          this.selectList = this.selectList.filter(item => !res.has(item.powerId) && res.set(item.powerId, 1));
        },
        handleCancelSelectAll2(selection) {
          var flag = true
          let arr = []
          for (var i = 0; i < this.selectList.length; i++) {
            flag = true
            for (var j = 0; j < this.otherRolesData.length ; j++) {
              if (this.selectList[i].powerId == this.otherRolesData[j].powerId) {
                flag = false
                break;
              }
            }
            if(flag){
              arr.push(this.selectList[i])
            }
          }
          this.selectList = arr
        },
        updateChecked() {
          for (var i = 0; i < this.otherRolesData.length; i++) {
            this.otherRolesData[i]._checked = false;
            for (var j = 0; j < this.selectList.length; j++) {
              if (this.selectList[j].powerId === this.otherRolesData[i].powerId) {
                this.otherRolesData[i]._checked = true;
                this.selectList[j].beUsed = "1";
              }
            }
          }
        },
        getUpdatedData(data){
            for(let i in data) {
                if (data[i].beUsed=='1') {
                    this.updatedData.push(data[i])
                } else {
                    if (data[i].children) {
                        this.getUpdatedData(data[i].children)
                    }
                }
            }
        },
        getTreeChecked(array){
            this.updatedData=array
        },
        transferChange(item){
            this.updatedData=[]
            this.transferData.forEach(res => {
                if(this.transferType==2){
                    item.forEach(element => {
                        if(res.structurecode==element){
                            this.updatedData.push(res)
                        }
                    });
                }else if(this.transferType==3) {
                    item.forEach(element => {
                        if(res.groupId==element){
                            this.updatedData.push(res)
                        }
                    });
                }
            })
        },
        //列表弹窗保存
        saveData(){
            if(this.transferType == 1){
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                    this.orgMasterSave()
                }
              })
            }else if(this.transferType == 2){
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                    this.posMasterSave()
                }
              })
            }else if(this.transferType == 3){
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                    this.userGroupMasterSave()
                }
              })
            }else if(this.transferType == 4){
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                    this.userMenuSave()
                }
              })
            }else if(this.transferType == 5){
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                    this.roleMasterSave()
                }
              })
            }else {
              this.$Modal.confirm({
                title: this.$notice('sureSave'),
                onOk: () => {
                }
              })
            }
        },
        orgMasterSave(){
          this.spinShow = true;
            let json={
                roleId:this.roleId,
                organizationStructureList:this.updatedData
            }
            axios.post('/roleMaster/insertAllOrgRoleMasterInfo',json).then(res => {
                if(res) {
                    this.$Message.success(this.$t('Save_Successful'));
                    this.spinShow = false;
                    this.visualPop=false
                    this.getData()
                }
            })
        },
        userMenuSave(){
            this.spinShow=true
            let json={
                roleId:this.roleId,
                menuMasterList:this.updatedData
            }
            axios.post('/roleMaster/saveMenuRoleMaster',json).then(res => {
                if(res) {
                    this.spinShow=false
                    this.$Message.success(this.$t('Save_Successful'));
                    this.visualPop2=false
                    this.getData()
                }
            })
        },
        posMasterSave(){
          this.loading2=true
          this.disabled=true
            this.selectList.forEach((item)=>{
              item.beUsed = "1"
            })
            let json={
                roleId:this.roleId,
                positionStructure:this.selectList
            }
            axios.post('/roleMaster/insertAllPosRoleMasterInfo',json).then(res => {
                if(res) {
                  this.loading2=false
                  this.disabled=false
                    this.$Message.success(this.$t('Save_Successful'));
                    this.showRolePosition=false
                    this.selectList = []
                    this.getData()
                }
            })
        },
        userGroupMasterSave(){
          this.spinShow = true;
            let json={
                roleId:this.roleId,
                userGroupMasterList:this.updatedData
            }
            axios.post('/roleMaster/insertAllUserGroupRoleMasterInfo',json).then(res => {
                if(res) {
                  this.spinShow = false;
                    this.$Message.success(this.$t('Save_Successful'));
                    this.visualPop1=false
                    this.getData()
                }
            })
        },
        roleMasterSave(){
          this.loading2=true
          this.disabled=true
            this.selectList.forEach((item)=>{
              item.beUsed = "1"
            })
            let json={
              roleId:this.roleId,
              powerMasterList: this.selectList
            }
            axios.post('/roleMaster/insertAllPowerRoleMasterInfo',json).then(res => {
                if(res) {
                  this.loading2=false
                  this.disabled=false
                    this.$Message.success(this.$t('Save_Successful'));
                    this.empoloyee = false
                    this.selectList = []
                    this.getData()
                }
            })
        },
        //新增弹窗
        addData(num){
            this.transferType=num,
            this.addItem={
                roleName:'',
                roleDescribe:'',
            }
            this.addPop=true
        },
        //新增编辑保存
        addSaveData(){
            this.$refs.addFormValidate.validate((valid) => {
                if (valid) {
                    this.$Modal.confirm({
                        title: this.$notice('sureSave'),
                        onOk: () => {
                            if(this.transferType==6){
                                axios.post('/roleMaster/updateMasterInfo',{...this.addItem}).then(res => {
                                    if(res) {
                                        this.$Message.success('修改成功');
                                        this.addPop=false
                                        this.$refs.addFormValidate.resetFields();
                                        this.getData()
                                    }
                                })
                            }else {
                                axios.post('/roleMaster/insertAllRoleMasterInfo',{...this.addItem}).then(res => {
                                    if(res) {
                                        this.$Message.success('新增成功');
                                        this.addPop=false
                                        this.$refs.addFormValidate.resetFields();
                                        this.getData()
                                    }
                                })
                            }
                        }
                    })
                }
            }) 
            
        },
        cancel(){
            this.visualPop=false
            this.visualPop1=false
            this.visualPop2=false
            if(this.transferType == 6){
                this.$refs.addFormValidate.resetFields();
            }
            this.treeData=[]
            this.transferData=[]
            
        },
        addCancel(){
            this.addPop=false
            this.$refs.addFormValidate.resetFields();
            this.addItem={
                roleName:'',
                roleDescribe:'',
            }
        },
        opendelete(row){
            this.$Modal.confirm({
                title: row.roleName + this.$notice('deletion'),
                content: '',
                onOk: () => {
                    axios.post('/roleMaster/deleteAllRoleMasterInfo',{roleId:row.roleId}).then(res => {
                        if(res) {
                            this.$Message.success('删除成功');
                            this.getData()
                        }
                    })
                }
            });
        },
        pageChange(val){
            this.pageInfo.pageNo=val
            this.getData()
        },
    }
}
</script>

<style lang="scss" scoped>
.btnGroup {
    display: flex;
    justify-content: flex-end;
    align-items: top;
}
.searchRow {
    display:flex;
    justify-content: space-between;
}
@media (max-width: 500px) {
  .searchRow{
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
  }
}
/deep/.ivu-input-group .ivu-input-search {
    background: #7f8df1 !important;
    border-color: #7f8df1 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/RolePermissionsMain/RolePermissionsMain.vue